import React from "react";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";
import "../registerFonts";

import { Header } from "./Header";
import { Section } from "./Section";
import { Employment } from "./Employment";
import { Education } from "./Education";

const styles = StyleSheet.create({
  page: {
    flexDirection: "col",
    backgroundColor: "#fff",
    fontFamily: "Roboto",
    lineHeight: 1.5,
    padding: 32,
    fontSize: 10
  },
  employmentHistory: {
    paddingTop: 4
  }
});

export function Resume({ content }) {
  const data = content;

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Header
          name={data.name}
          phone={data.phone}
          email={data.email}
          website={data.website}
          address={data.address}
          profession={data.profession}
          github={data.github}
        />

        <Section name="Summary">
          <Text>{data.summary}</Text>
        </Section>

        <Section name="Employment history">
          {data.employment.map((employment, i) => (
            <Employment
              key={i}
              employment={employment}
              lastChild={i === data.employment.length - 1}
            />
          ))}
        </Section>

        <Section name="Education">
          <View style={styles.employmentHistory}>
            {data.education.map((education, i) => (
              <Education
                key={i}
                education={education}
                lastChild={i === data.education.length - 1}
              />
            ))}
          </View>
        </Section>
      </Page>
    </Document>
  );
}
